{
  "auth": {
    "agree": "Я согласен",
    "createAccount": "Создать аккаунт",
    "createNewAccount": "Создать новый аккаунт",
    "email": "Email",
    "login": "Логин",
    "password": "Пароль",
    "recover_password": "Восстановить пароль",
    "sign_up": "Регистрация",
    "keep_logged_in": "Запомнить",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Сбросить пароль"
  },
  "404": {
    "title": "Эта страница последняя.",
    "text": "Если вы счиате, что это ошибка, напишите нам ",
    "back_button": "На главную"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "routes": "Построение маршрутов",
    "dashboard": "Лента",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Настройки Аккаунта",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects",
    "workouts": "Тренировки",
    "upload_workouts": "Загрузить",
    "list_workouts": "Мои"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Выход",
    "profile": "Профиль",
    "settings": "Настройки",
    "billing": "Платежы",
    "faq": "FAQ",
    "helpAndSupport": "Помощь",
    "projects": "Projects",
    "account": "Аккаунт",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Поиск",
    "noOptions": "Элементы не найдены",
    "ok": "ОК",
    "cancel": "Отмена",
    "uploadFile": "Выбрать файл",
    "undo": "Отменить",
    "dropzone": "Перетащите файл сюда для загрузки",
    "fileDeleted": "Файл удалён"
  },
  "workout": {
    "hide_start_end": "Скрыть начало и конец трека",
    "virtualPower": "Вирт. мощность",
    "virtualPowerBtn": "Рассчитать вирт. мощность",
    "virtualPowerBikeType": "Тип велосипеда",
    "virtualPowerRoad": "Шоссейный",
    "virtualPowerOther": "Другой",
    "virtualPowerSurface": "Покрытие",
    "virtualPowerAsphalt": "Асфальт",
    "virtualPowerGravel": "Гравий",
    "virtualPowerDirt": "Грязь",
    "virtualPowerSnow": "Снег",
    "virtualPowerCalculate": "Рассчитать",
    "virtualPowerNeedWeight": "Сначала укажите вес в настройках профиля"
  },
  "preferences": {
    "weight": "Вес (кг)"
  }
}
